import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/business/containerLadingOrderCargo/page',
    method: 'get',
    params
  })
}

export function cargoDetailList(params) {
  return request({
    url: '/api/business/containerLadingOrderCargo/cargoDetailList',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/business/containerLadingOrderCargo',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/business/containerLadingOrderCargo',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/business/containerLadingOrderCargo/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/business/containerLadingOrderCargo',
    method: 'get',
    params: {
      id
    }
  })
}
